(() => {
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'EUR'}).format((cents||0)/100);

  const intro = document.querySelector('[data-qc-intro]');
  if (intro) {
    const seen = sessionStorage.getItem('qcIntroSeen');
    if (seen) intro.classList.add('is-gone');
    else {
      sessionStorage.setItem('qcIntroSeen','1');
      setTimeout(() => intro.classList.add('is-gone'), 520);
    }
  }

  const menu = document.querySelector('[data-qc-menu]');
  const openMenu = () => { if(!menu) return; menu.classList.add('is-open'); menu.setAttribute('aria-hidden','false'); document.body.classList.add('qc-menu-lock'); };
  const closeMenu = () => { if(!menu) return; menu.classList.remove('is-open'); menu.setAttribute('aria-hidden','true'); document.body.classList.remove('qc-menu-lock'); };
  document.addEventListener('click', e => {
    if (e.target.closest('.qc-menu-trigger')) { e.preventDefault(); openMenu(); }
    if (e.target.closest('[data-qc-menu-close]')) { e.preventDefault(); closeMenu(); }
  });

  const drawer = document.querySelector('[data-qc-cart]');
  const itemsEl = document.querySelector('[data-qc-cart-items]');
  const totalEl = document.querySelector('[data-qc-cart-total]');
  const countEls = () => document.querySelectorAll('.qc-cart-count');

  async function getCart(){ const r=await fetch('/cart.js',{headers:{Accept:'application/json'}}); return r.json(); }
  function renderCart(cart){
    countEls().forEach(el => el.textContent = cart.item_count);
    if(totalEl) totalEl.textContent = money(cart.total_price);
    if(!itemsEl) return;
    if(!cart.items.length){
      itemsEl.innerHTML='<p class="qc-cart__empty">YOUR BAG IS<br>QUIETLY EMPTY.</p>';
      return;
    }
    itemsEl.innerHTML=cart.items.map(item => `
      <article class="qc-cart-item">
        <a href="${item.url}"><img src="${item.image || ''}" alt=""></a>
        <div class="qc-cart-item__info">
          <strong>${item.product_title}</strong>
          <small>${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</small>
          <small>${money(item.final_line_price)}</small>
          <div class="qc-cart-item__qty">
            <button type="button" data-qc-change="${item.key}" data-qc-qty="${Math.max(0,item.quantity-1)}">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-qc-change="${item.key}" data-qc-qty="${item.quantity+1}">+</button>
          </div>
        </div>
      </article>`).join('');
  }
  async function refreshCart(){ try{ const cart=await getCart(); renderCart(cart); return cart; }catch(e){ return null; } }
  async function openCart(){
    if(!drawer) return;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.classList.add('qc-menu-lock');
    await refreshCart();
  }
  function closeCart(){
    if(!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.classList.remove('qc-menu-lock');
  }

  document.addEventListener('click', async e => {
    const cartLink=e.target.closest('.qc-cart-trigger');
    if(cartLink){ e.preventDefault(); openCart(); }
    if(e.target.closest('[data-qc-cart-close]')){ e.preventDefault(); closeCart(); }
    const change=e.target.closest('[data-qc-change]');
    if(change){
      e.preventDefault();
      change.disabled=true;
      await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:change.dataset.qcChange,quantity:Number(change.dataset.qcQty)})});
      await refreshCart(); change.disabled=false;
    }
  });

  document.addEventListener('change', e => {
    const radio=e.target.closest('[data-qc-variant-radio]');
    if(!radio) return;
    const root=radio.closest('[data-qc-product]');
    if(!root) return;
    root.querySelectorAll('[data-qc-variant-input]').forEach(el => el.value=radio.value);
    const stickyPrice=root.querySelector('[data-qc-sticky-price]');
    if(stickyPrice) stickyPrice.textContent=radio.dataset.price || '';
    const available=radio.dataset.available==='true';
    root.querySelectorAll('[data-qc-submit]').forEach(btn => {
      btn.disabled=!available;
      btn.textContent=available?'ADD TO BAG':'CURRENTLY UNAVAILABLE. DRAMATIC.';
    });
  });

  document.addEventListener('submit', async e => {
    const form=e.target.closest('[data-qc-product-form]');
    if(!form) return;
    e.preventDefault();
    const btn=form.querySelector('[data-qc-submit]');
    if(btn) btn.disabled=true;
    try{
      const data=new FormData(form);
      const r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});
      if(!r.ok) throw new Error('add');
      await openCart();
    }catch(err){
      if(btn){ btn.textContent='TRY AGAIN. QUIETLY.'; setTimeout(()=>btn.textContent='ADD TO BAG',1500); }
    }finally{
      if(btn && !btn.textContent.includes('UNAVAILABLE')) btn.disabled=false;
    }
  });

  document.addEventListener('click', e => {
    const sticky=e.target.closest('[data-qc-sticky-submit]');
    if(!sticky) return;
    e.preventDefault();
    const root=sticky.closest('[data-qc-product]');
    root?.querySelector('[data-qc-product-form]')?.requestSubmit();
  });

  const cursor=document.querySelector('[data-qc-cursor]');
  if(cursor && matchMedia('(pointer:fine)').matches){
    document.addEventListener('mousemove',e=>{cursor.style.left=e.clientX+'px';cursor.style.top=e.clientY+'px';});
    document.addEventListener('mouseover',e=>{
      const target=e.target.closest('[data-qc-cursor-label]');
      if(target){cursor.textContent=target.dataset.qcCursorLabel||'VIEW';cursor.classList.add('is-on');}
    });
    document.addEventListener('mouseout',e=>{
      if(e.target.closest('[data-qc-cursor-label]')) cursor.classList.remove('is-on');
    });
  }

  document.addEventListener('click',e=>{
    const a=e.target.closest('a[href]');
    if(!a || e.defaultPrevented || a.target==='_blank' || a.hasAttribute('download') || a.classList.contains('qc-cart-trigger')) return;
    const href=a.getAttribute('href');
    if(!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
    if(a.origin===location.origin){
      e.preventDefault(); document.body.classList.add('qc-leaving'); setTimeout(()=>location.href=a.href,160);
    }
  });
})();